import { Button, Stack, ThemeIcon, Title } from '@mantine/core';
import { IconAlertCircle } from '@tabler/icons-react';
import cn from 'classnames';
import * as React from 'react';

import Text from 'components/shared/Text';
import { useResponsiveProp } from 'hooks/useResponsiveProp';

import s from './ErrorStub.module.scss';

type Props = {
  fullHeight?: boolean;
  className?: string;
  heading?: string;
  title: string;
  onRetry?: () => void;
  retryLabel?: string;
};

const ErrorStub: React.FC<Props> = ({
  fullHeight,
  className,
  heading = 'Произошла ошибка',
  title,
  onRetry,
  retryLabel = 'Повторить',
}) => {
  const titleOrder = useResponsiveProp({ desktop: 3, phone: 4 });
  const headingSize = useResponsiveProp({ desktop: 'h4', phone: 'h5' });

  return (
    <div className={cn(s.root, fullHeight && s['root_full-height'], className)}>
      <div className={s.root__container}>
        <Stack gap="lg" align="center">
          <Stack gap="md" align="center">
            <ThemeIcon radius="md" size="xl" variant="outline" color="gray">
              <IconAlertCircle color="var(--mantine-color-text)" />
            </ThemeIcon>

            <Stack align="center" gap="xs">
              <Title order={titleOrder} size={headingSize} fw={600} variant="text" ta="center">
                {heading}
              </Title>
              <Text className={s.root__description} size="sm" ta="center" c="gray">
                {title}
              </Text>
            </Stack>
          </Stack>

          {onRetry ? (
            <Button className={s.root__button} fullWidth size="xm" onClick={onRetry}>
              {retryLabel}
            </Button>
          ) : null}
        </Stack>
      </div>
    </div>
  );
};

export default React.memo(ErrorStub);
